import OctTags from '@/components/tags/OctTags.js'

// Properties
const props = {
  /** Id */
  id: {
    type: String,
    default: ''
  },
  /** News type */
  type: {
    type: String,
    default: 'physical'
  },
  /** News title */
  title: {
    type: String,
    default: ''
  },
  /** News title for Press */
  titlePress: {
    type: String,
    default: ''
  },
  /** News title */
  newsTitle: {
    type: String,
    default: ''
  },
  /** News title in English */
  newsTitleEN: {
    type: String,
    default: ''
  },
  /** News mail body */
  body: {
    type: String,
    default: 'HTML mail body'
  },
  /** News mail body for press */
  bodyPress: {
    type: String,
    default: 'HTML mail body'
  },
  /** Mail addresses to send */
  addresses: {
    type: Array,
    default: () => []
  },
  /** Time to send news mail */
  publishedAt: {
    type: Number,
    default: 0
  },
  /** Sent time */
  sentAt: {
    type: Number,
    default: 0
  },
  /** Sent reslult */
  result: {
    type: Boolean,
    default: null
  },
  /** News images */
  images: {
    type: Array,
    default: () => []
  },
  /** A exhibition linked to the news */
  exhibition: {
    type: Object,
    default () {
      return {
        artists: [],
        artworks: [],
        venues: [],
        data: {
          publishedArtworks: []
        }
      }
    }
  },
  /** Headline */
  headline: {
    type: String,
    default: ''
  },
  /** Headline in English */
  headlineEN: {
    type: String,
    default: ''
  },
  /** Description */
  description: {
    type: String,
    default: ''
  },
  /** Description in English */
  descriptionEN: {
    type: String,
    default: ''
  },
  /** Q&A */
  qa: {
    type: Array,
    default: () => []
  },
  /** Additional column follows description */
  columns: {
    type: Array,
    default: () => []
  },
  /** Author of the news */
  author: {
    type: Object,
    default: () => {
      return {}
    }
  },
  /** Articles */
  articles: {
    type: Array,
    default: () => []
  },
  /** Tags */
  tags: {
    type: Array,
    default: () => [] 
  },
  /** Additional data */
  data: {
    type: Object,
    default: () => {
      return {
        sent: false,
        links: [],
        documents: [],
        sentences: {
          title: null,
          headline: null,
          description: null
        },
        /** Indicate the news is related with art fairs */
        isArtFair: false
      }
    }
  },
  /** Public staus */
  status: {
    type: String,
    default: 'private'
  },
  /** Targets to send */
  newsType: {
    type: Array,
    default: () => []
  },
  /** Optout setting */
  ignoreOptout: {
    type: Number,
    default: 0
  }
}

export const createProps = () => {
  return Object.keys(props).reduce((acc, cur) => {
    acc[cur] = typeof props[cur].default === 'function' ?
      props[cur].default() : props[cur].default
    return acc
  }, {})
}

// Create computed property
const computed = Object.keys(props).reduce((acc, cur) => {
  acc[`$_octNews_${cur}`] = {
    get () {
      return this[cur]
    },
    set (val) {
      this.$emit(`update:${cur}`, val)
    }
  }
  return acc
}, {})

// Override computed status property
computed['$_octNews_status'] = {
  get () {
    return this.status === 'private'
  },
  set (val) {
    this.$emit('update:status', val ? 'private' : 'public')
  }
}

// Override computed addresses property
computed['$_octNews_addresses'] = {
  get () {
    return this.addresses.join(',')
  },
  set (val) {
    this.$emit('update:addresses', val.split(',').reduce((acc, cur)=> {
      // Strip unnecessary string
      const matches = cur.match(/[a-zA-Z0-9]+[a-zA-Z0-9._-]*@[a-zA-Z0-9_-]+[a-zA-Z0-9._-]+/)
      matches && acc.push(matches[0])

      return acc
    }, []))
  }
}

export default {
  name: 'OctNews',
  props: props,
  data () {
    return {
      categories: OctTags
    }
  },
  computed: {
    /** Categoris by slug */
    categoriesBySlug () {
      return this.categories.reduce((acc, cur) => {
        acc[cur.slug] = cur
        return acc
      }, {})
    },
    ...computed
  }
}
